import React from "react"

const Exit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <circle cx="22" cy="22" r="22" fill="#DAECE4" />
      <path
        d="M28.6743 15.3257C28.4657 15.1172 28.1828 15 27.8879 15C27.5929 15 27.31 15.1172 27.1014 15.3257L22 20.4271L16.8986 15.3257C16.69 15.1172 16.4071 15 16.1121 15C15.8172 15 15.5343 15.1172 15.3257 15.3257C15.1172 15.5343 15 15.8172 15 16.1121C15 16.4071 15.1172 16.69 15.3257 16.8986L20.4271 22L15.3257 27.1014C15.1172 27.31 15 27.5929 15 27.8879C15 28.1828 15.1172 28.4657 15.3257 28.6743C15.5343 28.8829 15.8172 29 16.1121 29C16.4071 29 16.69 28.8829 16.8986 28.6743L22 23.5729L27.1014 28.6743C27.31 28.8829 27.5929 29 27.8879 29C28.1828 29 28.4657 28.8829 28.6743 28.6743C28.8829 28.4657 29 28.1828 29 27.8879C29 27.5929 28.8829 27.31 28.6743 27.1014L23.5729 22L28.6743 16.8986C28.8829 16.69 29 16.4071 29 16.1121C29 15.8172 28.8829 15.5343 28.6743 15.3257Z"
        fill="#2B4346"
      />
    </svg>
  )
}

export default Exit
